export function ShareIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M20.7914 12.6067C21.0355 12.3975 21.1575 12.2929 21.2023 12.1684C21.2415 12.0591 21.2415 11.9396 21.2023 11.8303C21.1575 11.7058 21.0355 11.6012 20.7914 11.3919L12.3206 4.13129C11.9004 3.77109 11.6903 3.59099 11.5124 3.58658C11.3578 3.58275 11.2101 3.65067 11.1124 3.77054C11 3.90848 11 4.18522 11 4.73869V9.03395C8.86532 9.4074 6.91159 10.4891 5.45971 12.1132C3.87682 13.8838 3.00123 16.1753 3 18.5503V19.1623C4.04934 17.8982 5.35951 16.8758 6.84076 16.1652C8.1467 15.5387 9.55842 15.1676 11 15.0698V19.2599C11 19.8134 11 20.0902 11.1124 20.2281C11.2101 20.348 11.3578 20.4159 11.5124 20.4121C11.6903 20.4076 11.9004 20.2275 12.3206 19.8673L20.7914 12.6067Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

export const displayName = "ShareIcon";
